/** Crashes-context enums and shapes for the SafeSystem apps that render the crashes overlay. */

import type { ILayerSource, IFeature as IGenericFeature } from '#lib/types.js';

export enum ECrashesModule {
	Crashes = 'Crashes'
}

export enum EProduct {
	Context = 'Context'
}

export enum ECrashes {
	CrashesHeatmap = 'Crashes (heatmap)',
	CrashesCircle = 'Crashes (circle)',
	// Must match UPLOADED_CRASHES_LAYER_ID in the shared customCrashesStore.
	UploadedCrashes = 'Uploaded crash data'
}

/** Layer-id union. Fulfils the generic `<L extends string>` slot. */
export type CrashesLayerId = ECrashes;

/** Operational feature — generic IFeature parameterised with EProduct. */
export type ICrashesFeature = IGenericFeature<EProduct>;

export interface ICrashesSystemLayers {
	[ECrashesModule.Crashes]: {
		[ECrashes.CrashesHeatmap]: ILayerSource | null;
		[ECrashes.CrashesCircle]: ILayerSource | null;
		[ECrashes.UploadedCrashes]?: ILayerSource | null;
	} | null;
}
